import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';
import {
  STATUS_ICON_LOADING, STATE_ICON_RUN, STATUS_ICON_STOP
} from '@/common/utils/statuses';

export enum NFS_SHARE_STATUSES {
  running = 'running',
  stopped ='stopped',
  remote = 'remote',
  creating = 'creating',
  removing = 'removing',
  stopping ='stopping',
  updating = 'updating'
}

export const NFS_SHARE_STATUS_TEXT: Record<string, string> = computedLocale(() => ({
  [NFS_SHARE_STATUSES.running]: i18n.t('Running'),
  [NFS_SHARE_STATUSES.stopped]: i18n.t('Stopped'),
  [NFS_SHARE_STATUSES.remote]: i18n.t('Remote'),
  [NFS_SHARE_STATUSES.creating]: i18n.t('Creating'),
  [NFS_SHARE_STATUSES.removing]: i18n.t('Removing'),
  [NFS_SHARE_STATUSES.stopping]: i18n.t('Stopping'),
  [NFS_SHARE_STATUSES.updating]: i18n.t('Updating'),
}));

export const NFS_SHARE_STATUSES_ICONS_MAP = {
  [NFS_SHARE_STATUSES.running]: STATE_ICON_RUN,
  [NFS_SHARE_STATUSES.stopped]: STATUS_ICON_STOP,
  [NFS_SHARE_STATUSES.remote]: STATE_ICON_RUN,
  [NFS_SHARE_STATUSES.creating]: STATUS_ICON_LOADING,
  [NFS_SHARE_STATUSES.removing]: STATUS_ICON_LOADING,
  [NFS_SHARE_STATUSES.stopping]: STATUS_ICON_LOADING,
  [NFS_SHARE_STATUSES.updating]: STATUS_ICON_LOADING,
};
